import { jsx } from "react/jsx-runtime";
import { DEFAULT_BADGE_TEXT_COLOR, DEFAULT_BADGE_BACKGROUND_COLOR } from "../constants.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
function FeatureBadge({
  text,
  backgroundColor,
  color
}) {
  if (!text) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      sx: {
        background: backgroundColor || DEFAULT_BADGE_BACKGROUND_COLOR,
        borderRadius: "4px",
        color: color || DEFAULT_BADGE_TEXT_COLOR,
        fontSize: "10px",
        fontWeight: 700,
        lineHeight: "14px",
        margin: "0 8px",
        padding: "3px 8px"
      },
      children: text
    }
  );
}
export {
  FeatureBadge
};
